// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/maximize-2.js';

import { paths } from '../generated/maximize-2';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('maximize-2', Original, paths);
